import { OrderDirection } from "common/contracts/order-direction";
import PaginationParameters from "common/contracts/pagination-parameters";

export class NetworkInvitationFilterParameters {

public name?: string;
public message?: string;
public status?: string;
public includeRejected: boolean = false;
public sentDate?: Date;
public minSentDate?: Date;
public maxSentDate?: Date;

    constructor(
        name?: string, 
        message?: string,
        status?: string,
        includeRejected?: boolean,
        sentDate?: Date,
        minSentDate?: Date,
        maxSentDate?: Date
    ) {
        this.name = name;
        this.message = message;
        this.status = status;
        this.includeRejected = includeRejected === true;
        this.sentDate = sentDate ? new Date(sentDate) : undefined;
        this.minSentDate = minSentDate ? new Date(minSentDate) : undefined;
        this.maxSentDate = maxSentDate ? new Date(maxSentDate) : undefined;
    }

    public asSearchParams(): URLSearchParams {
        const searchParams = new URLSearchParams();
        if (this.name) searchParams.append("name", this.name);
        if (this.message) searchParams.append("message", this.message);
        if (this.status) searchParams.append("status", this.status);
        if (this.includeRejected) searchParams.append("includeRejected", this.includeRejected.toString());
        if (this.sentDate) searchParams.append("sentDate", this.sentDate.toISOString());
        if (this.minSentDate) searchParams.append("minSentDate", this.minSentDate.toISOString());
        if (this.maxSentDate) searchParams.append("maxSentDate", this.maxSentDate.toISOString());
        return searchParams;
    }

    public isEqualTo(other: NetworkInvitationFilterParameters): boolean {
        if (!other) return false;
        return this.name === other.name &&
            this.message === other.message &&
            this.status === other.status &&
            this.includeRejected === other.includeRejected &&
            this.sentDate?.getTime() === other.sentDate?.getTime() &&
            this.minSentDate?.getTime() === other.minSentDate?.getTime() &&
            this.maxSentDate?.getTime() === other.maxSentDate?.getTime();
    }
}

export enum NetworkInvitationOrderField {
    Name = "Name",
    Message = "Message",
    Status = "Status",
    SentDate = "SentDate"
}

export class NetworkInvitationOrderParameters {
    orderBy?: NetworkInvitationOrderField;
    orderDir?: OrderDirection;

    constructor(
        orderBy?: NetworkInvitationOrderField,
        orderDir?: OrderDirection
    ) {
        this.orderBy = orderBy;
        this.orderDir = orderDir;
    }

    public asSearchParams(): URLSearchParams {
        const params = new URLSearchParams();
        if (this.orderBy) params.append("orderBy", this.orderBy);
        if (this.orderDir) params.append("orderDir", this.orderDir);
        return params;
    }

    public isEqualTo(other: NetworkInvitationOrderParameters): boolean {
        if (!other) return false;
        return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
    }
}


export default class NetworkInvitationQuery {
    public query?: string;
    filterParameters: NetworkInvitationFilterParameters;
    orderParameters: NetworkInvitationOrderParameters;
    paginationParameters: PaginationParameters;

    constructor(
        filterParameters: NetworkInvitationFilterParameters,
        orderParameters: NetworkInvitationOrderParameters,
        paginationParameters: PaginationParameters,
        query?: string
    ) {
        this.paginationParameters = paginationParameters;
        this.orderParameters = orderParameters;
        this.filterParameters = filterParameters;
        this.query = query;
    }

    public asSearchParams(): URLSearchParams {
        return new URLSearchParams([
            ["query", this.query ?? ""],
            ...this.paginationParameters.asSearchParams(),
            ...this.orderParameters.asSearchParams(),
            ...this.filterParameters.asSearchParams()
        ]);
    }

    isEqualTo(other: NetworkInvitationQuery): boolean {
        if (!other) {
            return false;
        }
        return this.query === other.query &&
            this.filterParameters.isEqualTo((other.filterParameters)) &&
            this.orderParameters.isEqualTo((other.orderParameters)) &&
            this.paginationParameters.isEqualTo((other.paginationParameters));
    }
}